import React, { useState } from 'react'
import { Dropdown } from "react-bootstrap";
import FlowChart from '../../components/FlowChart/FlowChart';
import MapBox from '../../components/MapBox/MapBox';
import TimeLine from '../../components/WorldMap/components/TimeLine/TimeLine';
import Filters from '../Scan/components/Filters/Filters';
import { GeoRiskData } from '../Scan/data/MapData';

interface RiskScanProps {
  mapHeight?: string;
  showMapControl?: boolean;
  isShowFilter?: boolean;
  mapZoom?: number;
}

export default function RiskScan({
  mapHeight,
  showMapControl,
  mapZoom,
  isShowFilter = true,
}: RiskScanProps) {
  const [isMapSelected, setMapSelected] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState({
    year: 2023,
    month: 4,
  });

  const onSelectedPeriod = (period: any) => {
    setSelectedPeriod(period);
  };
  return (
    <>
      <div className="mv-2 d-flex align-items-center justify-content-between ">
        {/* Filter */}
        {isShowFilter && (
          <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
              Filters
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Filters isDropdown={true}></Filters>
            </Dropdown.Menu>
          </Dropdown>
        )}

        {/* Switch */}

        <div className="btn-group">
          <button
            onClick={() => setMapSelected(true)}
            className={`btn btn-outline-secondary  ${
              isMapSelected && "bg-primary"
            }`}
          >
            <i className="icon-map-pin mr-1"></i>
            Map
          </button>
          <button
            onClick={() => setMapSelected(false)}
            className={`btn btn-outline-secondary  ${
              !isMapSelected && "bg-primary"
            }`}
          >
            <i className="icon-git-pull-request mr-1"></i>
            Flow
          </button>
        </div>
      </div>

      {isMapSelected ? (
        <>
          <MapBox
            mapHeight={mapHeight}
            zoom={mapZoom}
            showControl={showMapControl}
            riskMarkers={GeoRiskData}
          />
        </>
      ) : (
        <FlowChart />
      )}
    </>
  );
}
